// Company-wide facts. Sourced from the live sahajanandtechnologies.com bundle.

export const company = {
  name: "Sahajanand Technologies LLC",
  short: "STL",
  tagline: "Software built around your business",
  intro:
    "STL is not only a globally recognized IT company but also a family filled with talented experts that help global brands, enterprises, mid-size businesses or even startups with innovative solutions.",
  phone: "732-347-9171",
  email: "contact@sahajanandtechnologies.com",
  linkedin: "#",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/service" },
  { label: "Industries", to: "/industries" },
  { label: "Technologies", to: "/technology" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

// The former `stats` export ("50+ projects", "24/7 support") was presentational
// — invented — and is gone. Real counts are derived from the data on the pages
// that need them.
